module.exports = __webpack_public_path__ + "img/consist_be-composed_combine_mix_design_amalgam_concur_broken_star-512.54a3c188.png";